import { Box, Button, Divider, Grid, Slide, Typography } from "@material-ui/core"
import React, { useRef } from "react"
import { EnumFasesSacola } from "../../../cardapio-sacola"
import { useStyles } from "./confirmar-informacoes-styles"
import { FasesHeader } from "../components/fases-header/fases-header"
import { OkIcon } from "utils/Icons/ok-icon"
import { formatarCPFCNPJ } from "utils/cpfcnpj-format"
import { EnumTipoContato } from "models/enums/enum-tipo-contato"
import { phoneMask } from "utils/phone-mask"
import { EnumOpcoesDelivery } from "storage"
import { enderecoFormatado } from "utils/endereco-formatado"
import { PedidoValores } from "../../pedido-valores/pedido-valores"
import { EnumPagTpTransacao } from "api/cardapio/models/finalizadora/finalizadora-model"
import { EnumFasePagamento } from "../formas-pagamento/formas-pagamento"
import { MesaIcon } from "utils/Icons/mesa-icon"
import { ComandaIcon } from "components/icons/comanda-icon"
import { EmpresaModel } from "api/cardapio/models/empresa/empresa-model"
import { MapaIcon } from "components/icons/mapa-icon"
import { useNotificacoes } from "components"
import { usePedidos } from "services/providers/pedidos-provider"
import { CircularLoading } from "components/utils/circular-loading"
import { useDadosDeliveryStore } from "services/store/dados-delivery"
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario"

export type ConfirmarInformacoesProps = {
    faseSacola: EnumFasesSacola
    onClickProximaFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    onClickVoltarFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    handlePedidoFluxo: (nextOrBack: React.MutableRefObject<0 | 1>) => void
    setFasesPagamento: (fase: EnumFasePagamento) => void
    loadingInfoCliente: React.MutableRefObject<boolean>
    empresaDados: EmpresaModel | undefined
    mesaId: string
    pagamentoNaFinalizacao: boolean
    voltarParaFaseFinalizarPedido: React.MutableRefObject<boolean>
}

export const ConfirmarInformacoes = ({
    faseSacola,
    onClickProximaFase,
    onClickVoltarFase,
    handlePedidoFluxo,
    setFasesPagamento,
    loadingInfoCliente,
    empresaDados,
    mesaId,
    pagamentoNaFinalizacao,
    voltarParaFaseFinalizarPedido
}: ConfirmarInformacoesProps) => {
    const classes = useStyles();

    const faseFormas = faseSacola === EnumFasesSacola.ConfirmarInformacoes
    const { cliente, transacao, handleRegistroPix, carregandoRegistrarPix, getInfoPedidoLocal, isPedidoDelivery } = usePedidos()
    const nextOrBack = useRef<0 | 1>(1)
    const { showErrorMessage } = useNotificacoes()
    const { enderecoDelivery, tipoDelivery } = useDadosDeliveryStore()
    const pessoa = usePessoaUsuarioStore((state) => state.pessoa)

    const clienteTelefone = cliente?.contatos.find(x => x.tipo === EnumTipoContato.TELEFONE)?.valor
    const clienteEmail = cliente?.contatos.find(x => x.tipo === EnumTipoContato.EMAIL)?.valor

    const handleFluxoFinalizar = async () => {
        try {
            if (transacao?.tpTransacao === EnumPagTpTransacao.SAFRAPAY_WALLET) {
                onClickProximaFase(nextOrBack, EnumFasesSacola.FormaPagamento)
                setFasesPagamento(EnumFasePagamento.InformarCartao)
                return
            }
            if (transacao?.tpTransacao === EnumPagTpTransacao.SAFRA_PIX || transacao?.tpTransacao === EnumPagTpTransacao.S2PAY_PIX) {
                await handleRegistroPix()
                onClickProximaFase(nextOrBack, EnumFasesSacola.PagamentoPix)
                return
            }
            onClickProximaFase(nextOrBack, EnumFasesSacola.FazendoPedido)
        } catch (err: any) {
            showErrorMessage(err.message)
        }
    }

    const abrirMapa = () => {
        window.open(`https://www.google.com/maps/search/?api=1&query=${empresaDados?.logradouro}, ${empresaDados?.numero}, ${empresaDados?.bairro}, ${empresaDados?.municipio}, ${empresaDados?.uf}`, '_blank')
    }

    const handleClickVoltar = () => {
        if (mesaId) {
            if (pagamentoNaFinalizacao) {
                onClickVoltarFase(nextOrBack, EnumFasesSacola.FormaPagamento)
                return
            }
            onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
            return
        }
        onClickVoltarFase(nextOrBack, EnumFasesSacola.FormaPagamento)
    }

    const abrirEndereco = () => {
        voltarParaFaseFinalizarPedido.current = true
        onClickVoltarFase(nextOrBack, EnumFasesSacola.InformarEndereco)
    }

    return (
        <Slide direction={nextOrBack.current === 1 ? "left" : 'right'} mountOnEnter unmountOnExit in={faseFormas}>
            <Box height="100%" display="flex">
                {carregandoRegistrarPix && (
                    <CircularLoading tipo="FULLSIZED" />
                )}
                <Box height={"100%"} width={"100%"} className={classes.boxContainer}>
                    <FasesHeader titulo="Finalizar Pedido" voltar={handleClickVoltar} />
                    <Box className={classes.content}>
                        <div className={classes.scrollable}>
                            <Box display="flex" flexDirection="column" width='100%' height='100%' flex={1}>
                                <Box
                                    flex="1 1 auto"
                                    display='flex'
                                    flexDirection="column"
                                    p={2}
                                >
                                    {getInfoPedidoLocal().mesa && (
                                        <>
                                            <Box mb={4} display="flex" alignItems="center" justifyContent="space-around" width="100%">
                                                <Box display="flex" alignItems="center">
                                                    <MesaIcon tipo="BUTTON" />
                                                    <Typography variant="h5" style={{ fontWeight: 700 }}>
                                                        {getInfoPedidoLocal().mesa}
                                                    </Typography>
                                                </Box>
                                                {getInfoPedidoLocal().comanda && (
                                                    <Box display="flex" alignItems="center">
                                                        <ComandaIcon tipo="BUTTON" />
                                                        <Typography variant="h5" style={{ fontWeight: 700 }}>
                                                            {getInfoPedidoLocal().comanda}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </>
                                    )}
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Box>
                                            <Box mb={1}>
                                                <Typography variant="body1" style={{
                                                    fontWeight: 700
                                                }}>
                                                    Cliente
                                                </Typography>
                                            </Box>
                                            {cliente ? (
                                                <>
                                                    <Typography variant="body2">
                                                        {cliente?.cpfcnpj ? formatarCPFCNPJ(cliente.cpfcnpj) : ''}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        <Box component="span" fontWeight={700}>{cliente?.nome}</Box>
                                                    </Typography>
                                                    {clienteTelefone && (
                                                        <Typography variant="body2">
                                                            {phoneMask(clienteTelefone)}
                                                        </Typography>
                                                    )}
                                                    {clienteEmail && (
                                                        <Typography variant="body2">
                                                            {clienteEmail}
                                                        </Typography>
                                                    )}
                                                </>
                                            ) : (
                                                <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }} >
                                                    Nenhum cliente informado
                                                </Typography>
                                            )}
                                        </Box>
                                        {!pessoa && (
                                            <Button variant="text" onClick={() => {
                                                voltarParaFaseFinalizarPedido.current = true
                                                loadingInfoCliente.current = false
                                                onClickVoltarFase(nextOrBack, EnumFasesSacola.IdentificarCliente)
                                            }}>
                                                Alterar
                                            </Button>
                                        )}
                                    </Box>
                                    <Box my={3}>
                                        <Divider />
                                    </Box>
                                    <>
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Box>
                                                <Box mb={1}>
                                                    <Typography variant="body1" style={{
                                                        fontWeight: 700
                                                    }}>
                                                        Pagamento {
                                                            !transacao
                                                                ? ''
                                                                : transacao.pagamentoAReceber
                                                                    ? tipoDelivery === EnumOpcoesDelivery.Entrega
                                                                        ? 'na Entrega'
                                                                        : ' na Retirada'
                                                                    : 'no Site'
                                                        }
                                                    </Typography>
                                                </Box>
                                                {transacao ? (
                                                    <>
                                                        <Typography variant="body2">
                                                            {transacao?.pagamentoDescricao}
                                                        </Typography>
                                                        {/* {transacao?.valorPago ? (
                                                            <Typography variant="body2">
                                                                Valor: {' '}
                                                                <Box component="span" fontWeight={700}>
                                                                    R$ {toDecimalString(transacao.valorPago)}
                                                                </Box>
                                                            </Typography>
                                                        ) : ''} */}
                                                        {/* {transacao?.valorTroco && transacao.valorTroco > 0 ?
                                                            <Typography variant="body2">
                                                                Troco: {' '}
                                                                <Box component="span" fontWeight={700}>R$ {toDecimalString(transacao.valorTroco)}</Box>
                                                            </Typography>
                                                            : ''} */}
                                                    </>
                                                ) : (
                                                    <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }} >
                                                        Pagar depois
                                                    </Typography>
                                                )}
                                            </Box>
                                            {mesaId && !pagamentoNaFinalizacao ? (
                                                null
                                            ) : (
                                                <Button variant="text" onClick={() => onClickVoltarFase(nextOrBack, EnumFasesSacola.FormaPagamento)}>
                                                    Alterar
                                                </Button>
                                            )}
                                        </Box>
                                        <Box my={3}>
                                            <Divider />
                                        </Box>
                                    </>
                                    {isPedidoDelivery && (
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Box>
                                                <Box mb={1}>
                                                    <Typography variant="body1" style={{
                                                        fontWeight: 700
                                                    }}>
                                                        <Box component="span" fontWeight={700}>
                                                            {tipoDelivery === EnumOpcoesDelivery.Entrega ? 'Entrega' : 'Retirada'}
                                                        </Box>
                                                    </Typography>
                                                </Box>
                                                {tipoDelivery === EnumOpcoesDelivery.Retirada && (
                                                    <Typography variant="body2" style={{ fontWeight: 700, marginBottom: 8 }}>
                                                        Retirar em:
                                                    </Typography>
                                                )}
                                                <Box display="flex" alignItems="center">
                                                    <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                                                        {tipoDelivery === EnumOpcoesDelivery.Entrega ? enderecoFormatado(
                                                            enderecoDelivery?.logradouro || '',
                                                            enderecoDelivery?.numero || '',
                                                            enderecoDelivery?.bairro || '',
                                                            enderecoDelivery?.xMun || '',
                                                            enderecoDelivery?.uf || '',
                                                            enderecoDelivery?.complemento || '',
                                                            enderecoDelivery?.cep || '',
                                                            enderecoDelivery?.referencia || '',
                                                            true
                                                        ) : enderecoFormatado(
                                                            empresaDados?.logradouro || '',
                                                            empresaDados?.numero || '',
                                                            empresaDados?.bairro || '',
                                                            empresaDados?.municipio || '',
                                                            empresaDados?.municipio || '',
                                                            empresaDados?.complemento || '',
                                                            empresaDados?.cep || '',
                                                            undefined,
                                                            true
                                                        )}
                                                    </Typography>
                                                    {tipoDelivery === EnumOpcoesDelivery.Retirada && (
                                                        <Button variant="outlined" onClick={abrirMapa} className={classes.mapButton}>
                                                            <MapaIcon tipo="BUTTON" class={classes.mapIcon} />
                                                        </Button>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Button variant="text" onClick={abrirEndereco}>
                                                Alterar
                                            </Button>
                                        </Box>
                                    )}
                                </Box>
                                <Box p={2}>
                                    <Grid container spacing={2} className={classes.contentPayment}>
                                        <Grid item xs={12}>
                                            <PedidoValores />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                size="large"
                                                variant={"contained"}
                                                fullWidth
                                                color="primary"
                                                className={classes.espacamento}
                                                onClick={handleFluxoFinalizar}
                                            >
                                                <OkIcon tipo="BUTTON_PRIMARY" />
                                                Finalizar Pedido
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </div>
                    </Box>
                </Box>
            </Box>
        </Slide>
    )
}
